module.exports = __webpack_public_path__ + "img/A1947.e8489c2d.png";